export default {
    vehicles: [],
    vehicle: {
        name: null,
        registration: null,
        status: 1
    },
    vehicleSelected: false
};
